import ContentHeader from '../../../components/ui/account/content/__header'
import { useHeader } from '../../../utils/use-header'

import styles from './styles.module.scss'

import ExchangePage from './exchange'
import { useTranslation } from 'utils/use-translation'

const Exchange = () => {
  const { t } = useTranslation()
  const head = useHeader(t('exchange'))

  return (
    <div className={styles.wrapper}>
      {head}
      <ContentHeader className={styles.header} title={t('exchange_tab')}></ContentHeader>
      <ExchangePage showBalance={true} validatorRule="exchangeDepositAmount" />
    </div>
  )
}
export default Exchange
